import cn from 'clsx'

import css from './PhoneFrame.module.css'

export type PhoneType = 'ios' | 'android'

export type PhoneFrameProps = {
    type?: PhoneType
    src?: string
    alt?: string
}

export function PhoneFrame({ type = 'ios', src, alt = '' }: PhoneFrameProps) {
    return (
        <div
            className={cn(css.phoneFrame, {
                [css.phoneFrameIOS]: type === 'ios',
                [css.phoneFrameAndroid]: type === 'android',
            })}
        >
            <div className={css.phoneContainer}>{src && <img src={src} alt={alt} />}</div>
        </div>
    )
}
